/* eslint-disable no-shadow,no-underscore-dangle */
import { 
  CUSTOMER_HISTORY_GET, BOOKING_ADD, TIMEZONE_NAME_SET, CLEAR_CUSTOMER_HISTORY,
  VISIT_SELECT, VISIT_SELECT_FORMS, CUSTOMER_SET, TOGGLE_VISIT_FORM, SET_READONLY_MODE,
  ATTACHMENT_ADD, ATTACHMENT_LIST_SELECT
} from './action-modulation.type';
import CustomerHistoryService from '../services/customerHistory.service';

export const state = {
  selectedVisit: null,
  selectedVisitForms: null,
  timezoneName: null,
  bookingList: [],
  customerName: [],
  attachmentsList: [],
  selectedAttachmentList: false,
};

export const actions = {
  [CUSTOMER_HISTORY_GET](context, params) {
    context.commit(CLEAR_CUSTOMER_HISTORY);
    return CustomerHistoryService.getCustomerHistory(params[0], params[1])
      .then(({ data }) => {
        data.booking.forEach((b) => {
          context.commit(BOOKING_ADD, b);
        });
        data.attachments.forEach((a) => {
          context.commit(ATTACHMENT_ADD, a);
        });
        context.commit(TIMEZONE_NAME_SET, data.timezoneName);
        context.commit(CUSTOMER_SET, data.customer);
      })
      .catch(error => error);
  },
  [ATTACHMENT_LIST_SELECT](context) {
    return context.commit(ATTACHMENT_LIST_SELECT);
  },
  [VISIT_SELECT](context, visit) {
    return context.commit(VISIT_SELECT, visit);
  },
  [VISIT_SELECT_FORMS](context, forms) {
    return context.commit(VISIT_SELECT_FORMS, forms);
  },
  [TOGGLE_VISIT_FORM](context, index) {
    return context.commit(TOGGLE_VISIT_FORM, index);
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [BOOKING_ADD](state, booking) {
    state.bookingList.push(booking);
  },
  [ATTACHMENT_ADD](state, booking) {
    state.attachmentsList.push(booking);
  },
  [ATTACHMENT_LIST_SELECT](state) {
    state.selectedAttachmentList = !state.selectedAttachmentList;
    state.selectedVisit = null;
    state.selectedVisitForms = null;
  },
  [TIMEZONE_NAME_SET](state, timezone) {
    state.timezoneName = timezone;
  },
  [CUSTOMER_SET](state, customer) {
    state.customer = customer;
  },
  [CLEAR_CUSTOMER_HISTORY](state) {
    state.bookingList = [];
    state.attachmentsList = [];
    state.timezoneName = null;
    state.selectedAttachmentList = false;
  },
  [VISIT_SELECT](state, visit) {
    state.selectedVisit = visit;
    state.selectedAttachmentList = false;
  },
  [VISIT_SELECT_FORMS](state, forms) {
    state.selectedVisitForms = forms;
  },
  [TOGGLE_VISIT_FORM](state, index) {
    state.selectedVisitForms.forEach((f) => {
      f.isShow = false;
    });
    state.selectedVisitForms[index].isShow = !state.selectedVisitForms[index].isShow;
  },
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/customerHistory.module.js